import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BYPASS_ROUTE_GUARD } from '@domgen/dgx-fe-common';
import { ApplianceDetailsFormField } from '@self-fix/util-models';

export const hasSelectedApplianceGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const bypassRoute = inject(BYPASS_ROUTE_GUARD, { optional: true });
  const platformId = inject(PLATFORM_ID);

  if (bypassRoute || isPlatformServer(platformId)) {
    return true;
  }

  const applianceCode = route.queryParamMap.get(
    ApplianceDetailsFormField.ApplianceCode
  );

  const planNumber = route.queryParamMap.get('planNumber');

  const destinationMap = {
    FR: ['CN', 'FZ', 'FF'],
    E4: ['E1'],
    TD: ['EA'],
    OV: ['RQ', 'CQ', 'CZ', 'CX', 'HB', 'DO', 'CK', 'CH'],
    AW: ['WD'],
    DW: [],
  };

  const codeFound = Object.keys(destinationMap).find(
    (code) => code === applianceCode
  );

  if (codeFound) return true;

  const redirectionMap: any = {};
  Object.keys(destinationMap).forEach((key) => {
    redirectionMap[key] = key;
    destinationMap[key].forEach((redirectionKey) => {
      redirectionMap[redirectionKey] = key;
    });
  });

  const redirectionCode = applianceCode ? redirectionMap[applianceCode] : null;

  if (redirectionCode) {
    return router.navigate(['/your-appliance'], {
      queryParams: { applianceCode: redirectionCode, planNumber },
      queryParamsHandling: 'merge',
    });
  }

  return router.navigate(['/'], {
    queryParams: { planNumber },
  });
};
